import { DashboardSection, DashboardSectionKey } from '@Types/index';
import { useLicenseStore } from '../../../models/useLicenseModel';
import { useState } from 'react';
import config from 'src/config';
import Organization from '@Components/Common/Organization';
import { Flex } from '@tonic-one/react';
import WidgetCategory from './WidgetCategory';
import OverallThreatDetection from './OverallThreatDetection';
import PDFReport from './PDFReport';
import Quishing from './Quishing';
import Ransomware from './Ransomware';
import Bec from './Bec';
import Summary from './Summary';
import SecurityRisk from './SecurityRisk';
import VirtualAnalyzer from './VirtualAnalyzer';
import Dlp from './Dlp';
import ServiceCheckbox from '../ServiceCheckbox';
import Scam from './Scam';

const ThreatDetection = () => {
  const { hasCasLicense } = useLicenseStore();
  const defaultWidgetCategory: DashboardSection =
    config.ui.widgetCategoryShowConfig;
  const [widgetsShowConfig, setWidgetsShowConfig] = useState<DashboardSection>(
    () => {
      const casWidgetCategory = localStorage.getItem('casWidgetCategory') || '';
      const dashboardWidgetShow: DashboardSection = casWidgetCategory
        ? JSON.parse(casWidgetCategory)
        : defaultWidgetCategory;
      if (!hasCasLicense) {
        dashboardWidgetShow[DashboardSectionKey.Ransomware] = false;
        dashboardWidgetShow[DashboardSectionKey.VA] = false;
        dashboardWidgetShow[DashboardSectionKey.BEC] = false;

        localStorage.setItem(
          'casWidgetCategory',
          JSON.stringify(dashboardWidgetShow)
        );
      }
      return dashboardWidgetShow;
    }
  );
  function widgetCategoryChange(obj: { [k: string]: boolean }) {
    const wc = JSON.parse(JSON.stringify(widgetsShowConfig));
    setWidgetsShowConfig({ ...wc, ...obj });
    localStorage.setItem(
      'casWidgetCategory',
      JSON.stringify({ ...wc, ...obj })
    );
  }
  return (
    <>
      {/* keep the tool-bar class, dashboard will query this dom */}
      <Flex className="tool-bar" m="24px 16px" gap="24px">
        <Organization />
        <ServiceCheckbox />
        {config.ui.hideFeature.dashboard.exportPDFReport ? '' : <PDFReport />}
        {config.ui.hideFeature.dashboard.widgetCategory ? (
          ''
        ) : (
          <WidgetCategory
            widgetsShowConfig={widgetsShowConfig}
            widgetCategoryChange={widgetCategoryChange}
          />
        )}
      </Flex>

      <Flex width="100%" direction="column" p="0 16px">
        {widgetsShowConfig.total_detections ? <OverallThreatDetection /> : ''}
        {widgetsShowConfig.scam ? <Scam /> : ''}
        {widgetsShowConfig.quishing ? <Quishing /> : ''}
        {widgetsShowConfig.ransomware ? <Ransomware /> : ''}
        {widgetsShowConfig.bec ? <Bec /> : ''}
        {widgetsShowConfig.summary ? <Summary /> : ''}
        {widgetsShowConfig.atp_srs ? <SecurityRisk /> : ''}
        {widgetsShowConfig.atp_va ? <VirtualAnalyzer /> : ''}
        {widgetsShowConfig.dp ? <Dlp /> : ''}
      </Flex>
    </>
  );
};

export default ThreatDetection;
